import * as Types from "redux/constants/App";

export const toggleHeaderFixed = (headerFixed) => ({
  type: Types.TOGGLE_HEADER_FIXED,
  payload: headerFixed,
});

export const setHeaderCoordinates = (headerCoordinates) => ({
  type: Types.SET_HEADER_COORDINATES,
  payload: headerCoordinates,
});

export const setSearchSentence = (sentence) => ({
  type: Types.SET_SEARCH_SENTENCE,
  payload: sentence,
});

export const updateViewportWidth = (width) => ({
  type: Types.UPDATE_VIEWPORT_WIDTH,
  payload: width,
});

export const reloadAppTable = () => ({
  type: Types.RELOAD_TABLE,
});

export const setQueryParams = (params) => ({
  type: Types.SET_QUERY_PARAMS,
  payload: params,
});

export const setSummaryPayload = (payload) => ({
  type: Types.SET_SUMMARY_PAYLOAD,
  payload,
});

export const resetQueryParams = () => ({
  type: Types.RESET_QUERY_PARAMS,
});

export const setTableMiscs = (payload) => ({
  type: Types.SET_TABLE_MISCS,
  payload,
});

export const setTableMiscsStatus = (payload) => ({
  type: Types.SET_TABLE_MISCS_STATUS,
  payload,
});

export const setSeacherHeader = (payload) => ({
  type: Types.SET_SEARCHER_HEADER,
  payload,
});
